import { confirmWarrantComponent } from './confirmWarrant.component';
import { transferringStateName } from '../../../../tickets/tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const confirmWarrantStateName = `${transferringStateName}.confirmWarrant`;

export const confirmWarrantState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: confirmWarrantStateName,
    url: '/confirm/:ticketId',
    component: confirmWarrantComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket(),
      stateIndex: () => 1 // Second step for a new transferring request ticket
    },
    params: {
      ticketId: null, // optional
      customer: null  // optional
    }
  });
};
